import React from 'react';
import { useTranslation } from 'react-i18next';
import './SuspendedAccountModal.css';

const SuspendedAccountModal = ({ isOpen, onClose, message }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';

  if (!isOpen) return null;

  return (
    <div className="suspended-modal-overlay" onClick={onClose}>
      <div className="suspended-modal" dir={isRTL ? 'rtl' : 'ltr'} onClick={(e) => e.stopPropagation()}>
        <div className="suspended-modal-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <circle cx="12" cy="17" r="0.8" fill="#dc2626" stroke="none" />
          </svg>
        </div>
        <h3>{t('login.suspendedAccount.title', 'Account Suspended')}</h3>
        <p className="suspended-modal-message">
          {message || t('login.suspendedAccount.defaultMessage', 'Your account has been temporarily suspended. If you think this was a mistake, please contact our support team via email at support@sulhafa.com. Thank you for your understanding.')}
        </p>
        <div className="suspended-modal-actions">
          <button className="suspended-modal-ok" onClick={onClose}>
            {t('common.ok', 'OK')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuspendedAccountModal;
